import { z } from 'zod';

import { type AnyZodSchema } from '@Common/types/zod/utils';

export const ZOD_STRING_PARSER = Symbol('ZOD_STRING_PARSER');

/**
 * should be used to transform string values to another type
 * @param type the resulting zod validator
 * @param pipe the zod validator that should be used to transform the value
 * @returns a zod validator that transforms a string to the type
 */
export function createZodStringParser<Type extends AnyZodSchema>(type: Type, pipe: AnyZodSchema) {
  const validator = z.preprocess((input) => {
    const result = z.safeParse(pipe, input);
    return (result.success ? result.data : input) as z.ZodType<
      z.output<Type>,
      z.input<Type> | string
    >;
  }, type) as unknown as z.ZodType<z.output<Type>, z.input<Type> | string>;
  // to identify if the validator is already parsing strings correctly
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (validator as any)[ZOD_STRING_PARSER] = true;
  return validator;
}

export function isZodStringParser(value: unknown) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return ((value as any)?.[ZOD_STRING_PARSER] as true | undefined) ?? false;
}
